export default {
	active: "Active",
	createdBy: "Created by {name}",
	dialogTitle: "Active messages",
	hiddenContent: "Protected content — click reveal to read",
	hideResolved: "Hide resolved messages",
	hideShort: "Hide",
	noResolvedMessages: "No resolved messages",
	privacyNote: "Closing this hides every message again.",
	revealShort: "Reveal",
	showResolved: "Show resolved messages",
	view: "View",
	viewMessages: "View messages",
	form: {
		messageLabel: "Message",
		messagePlaceholder: "Describe the message...",
		severityLabel: "Severity",
		typeLabel: "Type",
	},
	messages: {
		createError: "Error creating message",
		created: "Message created successfully",
		deleteError: "Error deleting message",
		deleted: "Message deleted",
		loadError: "Error loading messages",
		resolveError: "Error resolving message",
		resolved: "Message resolved",
	},
	newMessage: "New Message",
	noMessages: "No messages",
	resolve: "Resolve",
	resolved: "Resolved",
	resolvedBy: "Resolved by {name} on {date}",
	severity: {
		CRITICAL: "Critical",
		LOW: "Low",
		NORMAL: "Normal",
	},
	title: "Messages",
	type: {
		ALERT: "Alert",
		NOTE: "Note",
		PENDENCY: "Pendency",
		REPLENISHMENT: "Replenishment",
	},
};
